<template>
  <ul class="sidebar-menu">
    <li class="header">总揽</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">总体数据</span>
      </a>
    </router-link>

    <li class="header">商品管理</li>
    <router-link tag="li" class="pageLink" to="/category">
      <a>
        <i class="fa fa-sitemap"></i>
        <span class="page">商品分类</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/goods">
      <a>
        <i class="fa fa-table"></i>
        <span class="page">商品列表</span>
      </a>
    </router-link>
    <!--
    <li class="treeview">
      <a href="#">
        <i class="fa fa-folder-o"></i>
        <span>Files</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li>
          <a href="#">
            <i class="fa fa-file-word-o"></i> Item 1
          </a>
        </li>
        <li>
          <a href="#">
            <i class="fa fa-file-picture-o"></i> Item 2
          </a>
        </li>
        <li>
          <a href="#">
            <i class="fa fa-file-pdf-o"></i> Item 3
          </a>
        </li>
      </ul>
    </li>
    -->
    <li class="header">订单管理</li>
    <router-link tag="li" class="pageLink" to="/order">
      <a>
        <i class="fa fa-book"></i>
        <span class="page">订单列表</span>
      </a>
    </router-link>
    <!--
    <router-link tag="li" class="pageLink" to="/server">
      <a>
        <i class="fa fa-hdd-o"></i>
        <span class="page">订单分析</span>
      </a>
    </router-link>
    -->

    <li class="header">设置</li>
    <router-link tag="li" class="pageLink" to="/systemsettings/detail/1">
      <a>
        <i class="fa fa-wrench"></i>
        <span class="page">系统配置</span>
      </a>
    </router-link>
  </ul>
</template>
<script>
export default {
  name: 'SidebarMenu'
}
</script>
<style>
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?4cef2bc5